import { c as _c } from "react/compiler-runtime";
import type { EntityOnboarding } from '@onefootprint/request-types/dashboard';
import { CodeInline } from '@onefootprint/ui';
import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { OnboardingTraceLink } from '@/components';
import { Subsection } from '@/components/entity-onboarding-details';
import useOnboardingKindText from '@/hooks/use-onboarding-kind-text';
import useStatusText from '@/hooks/use-status-text';
import { getStatusColor, getTimestampText, isAutomaticCheckOnboarding, onboardingHasPlaybook } from '../../../../utils';
import BusinessLink from './components/business-link';
type Field = {
  label: string;
  value: ReactNode;
};
type OnboardingMoreInfoProps = {
  onboarding: EntityOnboarding;
};
const OnboardingMoreInfo = t0 => {
  const $ = _c(31);
  const {
    onboarding
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "onboardings"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("entity-details", t1);
  const onboardingKindT = useOnboardingKindText();
  const statusT = useStatusText();
  let t2;
  if ($[1] !== onboarding.status) {
    t2 = getStatusColor(onboarding.status);
    $[1] = onboarding.status;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const statusColor = t2;
  let t3;
  if ($[3] !== onboarding.timestamp) {
    t3 = getTimestampText(onboarding.timestamp, true);
    $[3] = onboarding.timestamp;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const timestampText = t3;
  let T0;
  let t4;
  let t5;
  let t6;
  if ($[5] !== onboarding || $[6] !== onboardingKindT || $[7] !== statusColor || $[8] !== statusT || $[9] !== t || $[10] !== timestampText) {
    const t7 = t(_temp3);
    let t8;
    if ($[15] !== onboarding.kind || $[16] !== onboardingKindT) {
      t8 = onboardingKindT(onboarding.kind);
      $[15] = onboarding.kind;
      $[16] = onboardingKindT;
      $[17] = t8;
    } else {
      t8 = $[17];
    }
    let t9;
    if ($[18] !== t8) {
      t9 = <p className="text-body-2 text-primary">{t8}</p>;
      $[18] = t8;
      $[19] = t9;
    } else {
      t9 = $[19];
    }
    let t10;
    if ($[20] !== onboarding.id) {
      t10 = <CodeInline>{onboarding.id}</CodeInline>;
      $[20] = onboarding.id;
      $[21] = t10;
    } else {
      t10 = $[21];
    }
    const summaryFields = [...(onboardingHasPlaybook(onboarding) && onboarding.playbook ? [{
      label: t(_temp),
      value: <OnboardingTraceLink className="max-w-full whitespace-normal! text-left" onboardingId={onboarding.id} playbook={onboarding.playbook} hasGraphTrace={onboarding.hasGraphTrace} />
    }] : []), ...(isAutomaticCheckOnboarding(onboarding) && onboarding.status !== "pending" ? [] : [{
      label: t(_temp2),
      value: <div className={`text-label-2 text-${statusColor}`}>{statusT(onboarding.status)}</div>
    }]), {
      label: t7,
      value: t9
    }, {
      label: t(_temp4),
      value: t10
    }];
    let t11;
    if ($[22] !== timestampText) {
      t11 = <p className="text-snippet-1 text-primary">{timestampText}</p>;
      $[22] = timestampText;
      $[23] = t11;
    } else {
      t11 = $[23];
    }
    const timelineFields = [{
      label: t(_temp5),
      value: t11
    }, ...(onboarding.completedAt ? [{
      label: t(_temp6),
      value: <p className="text-snippet-1 text-primary">{getTimestampText(onboarding.completedAt, true)}</p>
    }] : []), ...(onboarding.businessInfo ? [{
      label: t(_temp7),
      value: <BusinessLink businessInfo={onboarding.businessInfo} />
    }] : []), ...(onboarding.externalId ? [{
      label: t(_temp8),
      value: <CodeInline>{onboarding.externalId}</CodeInline>
    }] : [])];
    const renderFields = _temp10;
    T0 = Subsection;
    t4 = "flex flex-col gap-4";
    t5 = renderFields(summaryFields);
    t6 = renderFields(timelineFields);
    $[5] = onboarding;
    $[6] = onboardingKindT;
    $[7] = statusColor;
    $[8] = statusT;
    $[9] = t;
    $[10] = timestampText;
    $[11] = T0;
    $[12] = t4;
    $[13] = t5;
    $[14] = t6;
  } else {
    T0 = $[11];
    t4 = $[12];
    t5 = $[13];
    t6 = $[14];
  }
  let t7;
  if ($[24] !== t4 || $[25] !== t5 || $[26] !== t6) {
    t7 = <div className={t4}>{t5}{t6}</div>;
    $[24] = t4;
    $[25] = t5;
    $[26] = t6;
    $[27] = t7;
  } else {
    t7 = $[27];
  }
  let t8;
  if ($[28] !== T0 || $[29] !== t7) {
    t8 = <T0>{t7}</T0>;
    $[28] = T0;
    $[29] = t7;
    $[30] = t8;
  } else {
    t8 = $[30];
  }
  return t8;
};
export default OnboardingMoreInfo;
function _temp($) {
  return $.moreInformation.playbook;
}
function _temp2($_0) {
  return $_0.moreInformation.outcome;
}
function _temp3($_1) {
  return $_1.moreInformation.type;
}
function _temp4($_2) {
  return $_2.moreInformation.onboardingId;
}
function _temp5($_3) {
  return $_3.moreInformation.onboardingStarted;
}
function _temp6($_4) {
  return $_4.moreInformation.onboardingCompleted;
}
function _temp7($_5) {
  return $_5.moreInformation.business;
}
function _temp8($_6) {
  return $_6.moreInformation.externalId;
}
function _temp9(t0) {
  const {
    label,
    value
  } = t0;
  return <div key={label} className="flex flex-col items-start gap-1 min-w-0"><dt className="text-label-2 text-tertiary">{label}</dt><dd className="max-w-full">{value}</dd></div>;
}
function _temp10(fields) {
  return <dl className="grid grid-cols-1 gap-x-6 gap-y-4 sm:grid-cols-2 lg:grid-cols-4">{fields.map(_temp9)}</dl>;
}